itsoftApp.createModule("scrollEffects", ["windowScroll"], function() {
    var module = this;
    var sliderInitialized = false;
    var parallaxInitialized = false;

    function ScrollEffects(self, classAnimate, oldClass, obj, callBack) {
        this._self = self;
        this._classAnimate = classAnimate;
        this._obj = obj,
        this._callBack = callBack;
        this._scrollPoint;
        this._oldClass = oldClass;
        this.init();
    }

    ScrollEffects.prototype.init = function() {
        var self = this;

        function show() {
            var scrolled = this.pageYOffset;

            self._scrollPoint = parseInt(self._self.getBoundingClientRect().top);
            // console.log(scrolled + window.innerHeight / 2  + " " + (self._scrollPoint + scrolled));
            if (scrolled + window.innerHeight / 1.3 >= (self._scrollPoint + scrolled)) {
                self.fadeIn();
            }
        }

        show();

        itsoftApp.modules.windowScroll.addEvent(show);
    }

    ScrollEffects.prototype.fadeIn = function() {
        if (typeof this._callBack === "function") {
            this._callBack.call(this._obj);
        } else {
            if (this._oldClass) {
                this._self.classList.remove(this._oldClass);

                if (this._self.classList.contains("js-parallax") && !parallaxInitialized) {
                    parallaxInitialized = true;
                    itsoftApp.modules.scrollParallax.callback();
                }

                if (this._self.classList.contains("js-slider") && !sliderInitialized) {
                    sliderInitialized = true;
                    itsoftApp.modules.slidersLibrary.callback();
                }

                if (this._self.classList.contains("js-tabs-section")) {
                    itsoftApp.modules.accordion.callback();
                }

                if (this._self.classList.contains("js-accordion")) {
                    itsoftApp.modules.accordion.callback();
                }

                this._oldClass = undefined;
            }
            this._self.classList.add(this._classAnimate);
        }
    }


    module.ScrollEffects = ScrollEffects;

});
